// Vendor Libs
import React, {Component} from 'react';

// Components
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {withLastLocation} from 'react-router-last-location';
import {get} from 'lodash';
import formHoc from './form-wrapper';
import ShelfForm from './shelf-form';

const formName = 'addShelf';

class AddShelf extends Component {
    state = {
        ready: false,
    };

    UNSAFE_componentWillMount() {
        const {searchData} = this.props;

        if (searchData) {
            this.setFormData();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {searchData} = this.props;

        if (searchData !== nextProps.searchData) {
            this.setFormData(nextProps);
            this.setState({ready: true});
        }
    }

    setFormData(props = this.props, context = this.context) {
        const {searchData} = this.props;

        context.setFieldValues({
            searchData,
        });
    }

    render() {
        const {match, lastLocation, searchData, history, className} = this.props;
        const {ready} = this.state;

        const parentShelfId = get(match.params, 'parentshelfid');
        //let redirectLocation = '/';

        // Was in edit-shelf.js

        // if (!parentShelfId) {
        //   parentShelfId = '0';
        // }

        // if (lastLocation) {
        //   redirectLocation = lastLocation.pathname;
        // }

        const addShelf = [];

        if (ready) {
            addShelf.push(
                <ShelfForm
                    className="add-shelf"
                    formName="addShelf"
                    historyProps={history}
                    key="1"
                    parentShelfId={parentShelfId}
                    redirectLocation={lastLocation ? lastLocation.pathname : '/'}
                    searchValues={searchData}
                />
            );
        }

        return <div className={classnames('shelf-detail', className)}>{addShelf}</div>;
    }
}

AddShelf.propTypes = {
    className: PropTypes.object,
    history: PropTypes.object,
    lastLocation: PropTypes.object,
    match: PropTypes.object,
    searchData: PropTypes.object,
};

AddShelf.contextTypes = {
    setFieldValues: PropTypes.func.isRequired,
};

export default withLastLocation(formHoc(AddShelf, formName));
